import get from 'lodash/get';
// import { selectMaxSchedulesLimit } from 'store/Config/selector';

export const selectSelectedSection = (state) => get(state, 'schedule.selectedSection', 'scheduledAgents');

export const selectScheduledAgentsTotal = (state) => get(state, 'schedule.scheduledAgents.total', 0);

export const selectScheduledCloudAgentsTotal = (state) => get(state, 'schedule.scheduledCloudAgents.total', 0);

export const selectSchedulersPage = (state, section) => get(state, `schedule.${section}.page`, 0);

export const selectSchedulersPageSize = (state, section) => get(state, `schedule.${section}.pageSize`, 0);

export const selectSchedulersSortBy = (state, section) => get(state, `schedule.${section}.sortBy`, 0);

export const selectSchedulersSortDirection = (state, section) => get(state, `schedule.${section}.sortDirection`, 0);

export const selectSchedulersTotal = (state, section) => get(state, `schedule.${section}.total`, 0);

export const selectFields = (state, section) => get(state, `schedule.${section}.fields`, []); // obtiene el listado de campos para la tabla

export const selectIsFetching = (state, section) => get(state, `schedule.${section}.isFetching`, false);

export const selectData = (state, section) => get(state, `schedule.${section}.list`, []);

export const selectLastSelected = (state) => get(state, 'schedule.lastSelected', {});

export const selectSchedulersSelected = (state) => get(state, 'schedule.schedulersSelected', []);

export const selectSchedulerSelected = (state) => get(state, 'schedule.schedulersSelected[0]', {});

export const allSchedulersAreSelected = (state) => {
  const section = selectSelectedSection(state);
  const schedulersList = selectData(state, section);
  const shedulersSelected = selectSchedulersSelected(state);
  return schedulersList.every((testScheduler) => shedulersSelected.some((scheduler) => scheduler.id === testScheduler.id)) && shedulersSelected.length > 0;
};
export const someSchedulerIsSelected = (state) => {
  return selectSchedulersSelected(state).length > 0;
};

export const selectWorkspaceSelected = (state) => get(state, 'faraday.workspaceSelected', {});

// selecciono el primer item del array, corresponde al ultimo row seleccionado en la tabla
export const selectAgentExecutors = (state) => get(state, 'schedule.schedulersSelected[0].value.agent.executors', {});

export const selectIsCreateSchedule = (state) => get(state, 'schedule.isCreateSchedule', false);

export const selectError = (state, section) => get(state, `schedule.${section}.error`, '');

export const selectErrorMessage = (state, section) => get(state, `schedule.${section}.errorMessage`, '');

export const selectScheduledAgentsCount = (state) => get(state, 'schedule.count.agentSchedulers', 0);

export const selectScheduledCloudAgentsCount = (state) => get(state, 'schedule.count.cloudAgentSchedulers', 0);

export const selectUserAgents = (state) => get(state, 'schedule.userAgents', []);

export const selectSchedulerDetail = (state) => get(state, 'schedule.schedulerDetail', {});
